<template>
    <div class="countDownBox">
        <countDown ref="countDown" :timestamp="remainTime" @callBack="onCountDownCallBack">
            <div class="pBox">
                {{ stateText[state] }}
                <p v-show="state !== 2"><span>{{ timeInfo.h }}</span>时<span>{{ timeInfo.m }}</span>分<span>{{ timeInfo.s }}</span>秒</p>
            </div>
        </countDown>
    </div>
</template>

<script>
import countDown from '@/components/countDown/countDown.vue'

export default {
    name: 'countDownBox',
    props: {
    },
    components: {
        countDown
    },
    data () {
        return {
            state: 0, // 0 未开始 1 进行中 2 已结束
            stateText: ['距下一轮开始还有', '距离本轮结束还有', '本轮已结束'],
            remainTime: 3, // 剩余时间
            nowTime: 0, // 当前时间
            timeInfo: {
                h: 0,
                m: 0,
                s: 0,
                isEnd: false,
                remainTime: 0
            }
        }
    },
    created () {

    },
    activated () {

    },
    mounted () {
    },
    methods: {
        /**
         * 给父组件调用的方法
         */
        startCountDown (now_time, nowTimeRange) {
            /* 剩余时间 */
            const remainTime = nowTimeRange.start - now_time
            if (remainTime <= 0) {
                this.remainTime = nowTimeRange.end - now_time
                if (this.remainTime < 0) {
                    /* 已结束 */
                    this.state = 2
                } else {
                    /* 活动中 */
                    this.state = 1
                }
            } else if (remainTime > 0) {
                /* 还没开始 */
                this.state = 0
                this.remainTime = nowTimeRange.start - now_time
            }
            this.$refs.countDown.end()
            this.$refs.countDown.start()
        },
        /**
         * 倒计时回调
         * @param {object} timeInfo
         */
        onCountDownCallBack (timeInfo) {
            this.timeInfo = timeInfo
            // this.$set(this, 'timeInfo', timeInfo)
            this.$emit('callBack', timeInfo)
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '../../../../assets/stylus/variables'
.countDownBox
    background-color #fed4d3
    height 88px
    line-height 85px
    text-align center
    margin 0 30px
    border-radius 16px 16px 0 0
    .pBox
        font-size 22px
        color #333333
        p
            display inline-block
            span
                display inline-block
                min-width 38px
                height 38px
                text-align center
                line-height 38px
                background-color #fc2d2d
                border-radius 10px
                font-size 24px
                color #fff
                margin 9px
</style>
